import { useEffect, useRef } from 'react';
import { Animated, Easing } from 'react-native';

import { tokens } from '@opendoor/tokens-studio/dist/bricks-next/tokens/Components';
import { getTokenValue } from '@tamagui/core';

import { Box } from '../../Box';

const { formLayout: formLayoutTokens } = tokens;

export type ProgressBarProps = {
  /**
   * The percentage completed in decimal form (0-1)
   */
  completed: number;
};

/**
 * Shows a progress bar. This component is only used internally for now, but
 * the props are exposed via the `BottomNav` component.
 */
export const ProgressBar = ({ completed }: ProgressBarProps) => {
  const width = useRef(new Animated.Value(0));
  useEffect(() => {
    Animated.timing(width.current, {
      toValue: completed > 1 ? 1 : completed < 0 ? 0 : completed,
      // TODO: see if we can use tokens for animation values
      duration: 800,
      easing: Easing.bezier(0.25, 0.1, 0.25, 1),
      useNativeDriver: false, // native driver doesn't support animating width
    }).start();
  }, [completed]);

  return (
    <Box
      backgroundColor={formLayoutTokens.color.border.progressbar.incomplete}
      height={formLayoutTokens.progressBar.height}
    >
      {/*
       * Have to use Animated.View instead of an animation prop because tamagui
       * doesn't support animating width/height in React Native yet (probably
       * related to the useNativeDriver: false above)
       */}
      <Animated.View
        style={{
          backgroundColor: getTokenValue(formLayoutTokens.color.border.progressbar.completed),
          height: '100%',
          width: width.current.interpolate({
            inputRange: [0, 1],
            outputRange: ['0%', '100%'],
          }),
        }}
      />
    </Box>
  );
};
